import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ed2fc54"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "18px",
    "margin-bottom": "15px"
  }
}, "申请信息", -1));
const _hoisted_2 = {
  class: "line"
};
const _hoisted_3 = {
  class: "line-item"
};
const _hoisted_4 = {
  class: "approval-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "18px",
    "margin-bottom": "20px"
  }
}, "申请进度", -1));
const _hoisted_6 = {
  key: 0
};
import { watch, computed } from 'vue';
import { ApprovalTypeMap } from '@/constant';
import { Close, Check } from '@element-plus/icons-vue';
export default {
  __name: 'ApprovalStep',
  props: {
    approvalProcess: {
      type: Object
    },
    active: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const descriptionComputed = computed(() => {
      return (approvalStatus, approvalTime) => {
        // console.log('approvalStatus, approvalTime', approvalStatus, approvalTime)
        if (approvalStatus === 2) {
          return `已审批${approvalTime}`;
        }
        if (approvalStatus === 3) {
          return `已拒绝${approvalTime}`;
        }
        if (approvalStatus === 1) {
          return '';
        }
        if (!approvalStatus) {
          return approvalTime;
        }
      };
    });
    watch(() => props.approvalProcess, val => {
      if (val.length) {
        console.log('val.length:', val.length);
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_step = _resolveComponent("el-step");
      const _component_el_steps = _resolveComponent("el-steps");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        shadow: "never",
        class: "approval-card",
        style: {
          "border": "none",
          "margin-bottom": "20px"
        }
      }, {
        default: _withCtx(() => {
          var _props$approvalProce;
          return [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, " 申请类型： " + _toDisplayString(((_props$approvalProce = __props.approvalProcess.approvalList) === null || _props$approvalProce === void 0 ? void 0 : _props$approvalProce.length) && _unref(ApprovalTypeMap)[__props.approvalProcess.approvalList[1]['applyApprovalType']]), 1)])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", null, [_createVNode(_component_el_steps, {
            active: __props.active,
            size: "large",
            "align-center": "",
            "finish-status": "success",
            space: 250
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.approvalProcess.approvalList, (item, index) => {
              return _openBlock(), _createBlock(_component_el_step, {
                key: item.id
              }, {
                icon: _withCtx(() => [_createElementVNode("div", {
                  class: "icon-box flex justify-center align-center",
                  style: _normalizeStyle([{
                    "padding": "2px",
                    "border": "2px solid #333",
                    "border-radius": "50%",
                    "box-sizing": "border-box"
                  }, {
                    color: __props.active < index + 1 ? 'grey' : item.approvalStatus !== 3 ? 'green' : 'red',
                    borderColor: __props.active < index + 1 ? 'grey' : item.approvalStatus !== 3 ? 'green' : 'red'
                  }])
                }, [item.approvalStatus !== 3 ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  size: "25"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(Check))]),
                  _: 1
                })) : (_openBlock(), _createBlock(_component_el_icon, {
                  key: 1,
                  size: "25"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(Close))]),
                  _: 1
                }))], 4)]),
                title: _withCtx(() => [_createElementVNode("div", {
                  style: _normalizeStyle({
                    color: __props.active < index + 1 ? 'grey' : item.approvalStatus !== 3 ? 'green' : 'red'
                  })
                }, _toDisplayString(item.auditorName), 5)]),
                description: _withCtx(() => [_createElementVNode("div", {
                  style: _normalizeStyle({
                    color: __props.active < index + 1 ? 'grey' : item.approvalStatus !== 3 ? 'green' : 'red'
                  })
                }, [_createElementVNode("div", null, _toDisplayString(descriptionComputed.value(item.approvalStatus, item.approvalTime)), 1), item.remark ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.remark), 1)) : _createCommentVNode("", true)], 4)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          }, 8, ["active"])])])];
        }),
        _: 1
      });
    };
  }
};